import React from 'react'
import { Avatar } from '@rmwc/avatar'
import '@rmwc/avatar/styles'

export function RadAvatar ({ ...rest }) {
  return (
    <Avatar {...rest} />
  )
}
